import Jumbotron from './Jumbotron';
import './Jumbotron.css';

export default Jumbotron;



// WEBPACK FOOTER //
// ./src/pages/Home/components/Jumbotron/index.js